module.exports = __webpack_public_path__ + "static/media/3.451a8334.jpg";